<script lang="ts">
import FichePrelevementEmis from '@/generated/fiches/FichePrelevementEmis.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: FichePrelevementEmis
})

</script>
